import { connect } from "react-redux";
import { getSelf, actionCreators as usersActions } from "../userInfo";
import ProfileToggler from "./profileToggler";
const mapStateToProps = (state) => ({
    user: getSelf(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(usersActions.getSelf())
});
export default connect(mapStateToProps, mapDispatchToProps)(ProfileToggler);
